module.exports = "img/flags/GB.5a4fec2.png";